export default "__VITE_ASSET__CKz8EWs$__"